/**
 * Thin wrapper around the Django JS catalog (window.django.catalog).
 *
 * The catalog is loaded on every page via:
 *   <script src="jsi18n/{{ LANGUAGE_CODE }}/djangojs.js"></script>
 *
 * It maps English source strings → translated strings, which is exactly
 * how Django's gettext works: the source string IS the key.
 *
 * We use `defaultValue` (the English text) as the lookup key so that
 * English pages work with zero catalog entries (defaultValue is returned as-is)
 * */
export function t(
  key: string,
  defaultValue: string,
  interpolations?: Record<string, unknown>
): string {
  const catalog = window.django?.catalog ?? {}
  let str = defaultValue in catalog ? catalog[defaultValue] : defaultValue
  if (interpolations) {
    for (const [k, v] of Object.entries(interpolations)) {
      str = str.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), String(v))
    }
  }
  return str
}
